import { render, staticRenderFns } from "./detailHeader.vue?vue&type=template&id=2ecd75ee&"
import script from "./detailHeader.vue?vue&type=script&lang=js&"
export * from "./detailHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports